export const CONTENT_ITEMS = [
  [
    'Аналитика цен за 3 года',
    'Технические характеристики',
    'Подборка похожих зданий с диапазонами цен',
    'Правообладатели и обременения по ним (при наличии выписки из Росреестра)',
  ],
  [
    'Вакантные помещения и объявления с Циан',
    'Кадастровый номер и стоимость',
    'Формат готовой презентации',
    'Информация по текущим арендаторам',
  ],
];
